import React from "react";
import Logo from "../assets/LogoeLav_1160.png"

const Stats = () => {
  return (
    <div className="w-full h-fit flex flex-col justify-center items-center p-1">
      <img className="w-[180px] md:w-[240px] hover:resize" src={Logo} alt="/"></img>
      <h1 className="text-5xl text-white font-medium text-center">A eLav em números estimativos</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 place-items-center mt-10 mb-10">
      
        <div className="flex flex-col justify-center items-center text-center m-3">
          <h1 className="text-6xl text-[rgb(97,198,44)] mb-3">94</h1>
          <h1 className="text-3xl text-white">Unidades no Brasil</h1>
        </div>
      
        <div className="flex flex-col justify-center items-center text-center m-3">
          <h1 className="text-6xl text-[rgb(97,198,44)] mb-3">+14</h1>
          <h1 className="text-3xl text-white">Milhões de litros de água economizados</h1>
        </div>
      
        <div className="flex flex-col justify-center items-center text-center max-w-[420px] m-3">
          <h1 className="text-6xl text-[rgb(97,198,44)] mb-3">+12</h1>
          <h1 className="text-3xl text-white">Milhões de litros de esgoto gerado reduzidos</h1>
        </div>
      </div>
    </div>
  )
}

export default Stats;